import React from "react";
import { Route, Routes } from "react-router";
import useTracker from "@/src/services/useTracker";
import CheckoutConfirmation from "@/src/containers/HigherOrderContainers/CheckoutConfirmation";
import StripeCheckout from "@/src/components/Checkout/StripeCheckout";
import DocumentGenerationFailed from "@/src/components/Payment/DocumentGenerationFailed/DocumentGenerationFailed";
import PaidPage from "@/src/containers/Pages/Payment/PaidPage/PaidPage";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";

export default function Checkout() {
  useTracker();

  return (
    <Routes>
      <Route path={""} element={<StripeCheckout />} />
      <Route path={"/bestaetigung"} element={<CheckoutConfirmation />} />
      <Route path={`dokumentenfehler`} element={<DocumentGenerationFailed />} />
      <Route path={`erfolgreich`} element={<PaidPage />} />
      <Route path={`*`} element={<Error404Page />} />
    </Routes>
  );
}
